export default __webpack_public_path__ + "static/media/kebab.8d81453c.jpg";